import { DoorSlidingOpenIcon } from './DoorSlidingOpenIcon';

/**
 * author: Michael Irigoyen
 * id B8358F0C-19A7-4E55-AF98-F4FEFA983148
 * name door-sliding-open
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door-sliding-open.svg
 * tags
 * - Home Automation 
 */
export const FrenchDoorOpenIcon = DoorSlidingOpenIcon;
export default FrenchDoorOpenIcon